<template>
  <div v-if="!!token" class="page-container">
    <div class="import-export-title primary-color import-export-title-margins">
      <v-icon color="secondary" class="arrow-back" @click="goBack()">arrow_back</v-icon>
      <span style="margin-left: 16px">Export attendees</span>
    </div>
    <div class="import-export-container import-export-container-margins">
      <div class="import-export-description-margins">
        You can export your attendees and all of their data here. Choose the appropriate format of
        the file depending on the purpose.
      </div>
      <div class="import-export-description-margins" style="margin-bottom: 0 !important">
        Choose format:
        <v-radio-group v-model="exportFormat">
          <v-radio color="primary" label="Excel" value="xlsx" />
          <v-radio color="primary" label="CSV" value="csv" />
        </v-radio-group>
      </div>
      <div class="import-export-buttons">
        <a
          download
          :href="`${serverURL}/files/events/${eventId}/export/attendees/${exportFormat}/${visibleFields}/${token}`"
        >
          <main-button depressed text="Export attendees" />
        </a>
      </div>
      <hidden-file-input
        ref="file-input"
        accept="text/csv .csv"
        max-file-size-mb="10"
        @file="processFile($event)"
      />
    </div>
    <div class="import-export-container import-export-container-margins">
      <module-title
        color="#0277BD"
        class="import-export-module-title-margins"
        title="Export analytics"
      />
      <div class="import-export-description-margins">
        Here you can export a full set of your event's analytics data stored in an Excel file.
        Analytics contain data such as...
      </div>
      <div class="import-export-buttons">
        <a
          download
          :href="`${serverURL}/files/events/${eventId}/export/analytics/xlsx/${visibleFields}/${token}`"
        >
          <main-button depressed text="Export analytics" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getExportToken } from '../../http'
import { serverURL, getVisibleFields } from '../../utils.js'
import HiddenFileInput from './../shared/hidden-file-input'
import ModuleTitle from './../shared/module-title.vue'

export default {
  name: 'export-container',
  components: {
    HiddenFileInput,
    ModuleTitle,
  },
  props: {
    eventId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      serverURL,
      token: undefined,
      exportFormat: 'xlsx',
      visibleFields: undefined,
    }
  },
  async created() {
    const { data } = await getExportToken(this.eventId)
    if (!data) {
      // handle
    }

    //TODO PUT QUERY PARAMS IN EXPORT URL FOR BETTER HANDLE
    this.token = data.token
    const localStorageVisibleFields = getVisibleFields(this.eventId)
    this.visibleFields = JSON.stringify(
      localStorageVisibleFields.filter(field => !field.includes('/')),
    )
  },
}
</script>

<style></style>
